export enum DEPOSIT_TYPE {
  PIPE = 1,
  WAVE = 2,
  MONEY = 3 
}